document.addEventListener("DOMContentLoaded", function() {
  const countryBlocks = document.querySelectorAll('.country-block');

  countryBlocks.forEach(block => {
    const links = block.querySelectorAll('.country-links a');
    if (links.length > 2) {
      // Hide all links after the second one
      links.forEach((link, index) => {
        if (index >= 2) {
          link.style.display = 'none';
        }
      });

      // Create and append the "Show more" button
      const showMoreButton = document.createElement('span');
      showMoreButton.classList.add('show-more');
      showMoreButton.textContent = 'Click for more';
      block.querySelector('.country-links').appendChild(showMoreButton);

      // Add click event to toggle the visibility of the additional links
      showMoreButton.addEventListener('click', function() {
        const hiddenLinks = block.querySelectorAll('.country-links a');
        hiddenLinks.forEach((link, index) => {
          if (index >= 2) {
            if (link.style.display === 'none') {
              link.style.display = 'block';
              showMoreButton.textContent = 'Show less';
            } else {
              link.style.display = 'none';
              showMoreButton.textContent = 'Click for more';
            }
          }
        });
      });
    }
  });
});
